<template>
  <div class="landing">
    <login-form></login-form>
    <!-- <affiliate-form></affiliate-form> -->
  </div>
</template>

<script>
//import AffiliateForm from "@/components/landing/AffiliateForm"
 import LoginForm from "@/components/landing/LoginForm"

export default {
  name: "test",
  components: {
  //  AffiliateForm,
     LoginForm
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="postcss">
.landing {
  width: 100%;
  min-height: 100vh;
}
</style>
